import {
  PurchaseProductDetailsAddonProductVariant,
  TranslateFn,
} from '@ancon/wildcat-types'
import { getFormattedCurrency } from '@ancon/wildcat-utils/currency'

export default function getPriceLabelForVariant(
  variant: PurchaseProductDetailsAddonProductVariant,
  showFreeLabel: boolean,
  hasFreeAddons: boolean,
  afterFreePrice: number,
  isBlocked: boolean,
  isOutOfStock: boolean,
  t: TranslateFn,
) {
  if (isBlocked) {
    return t('components.productDetailsModal.unavailable')
  }

  if (isOutOfStock) {
    return t('components.productDetailsModal.variantOutOfStock')
  }

  if (showFreeLabel) {
    return t('components.productDetailsModal.free')
  }

  return getFormattedCurrency(
    hasFreeAddons ? afterFreePrice : variant.price.unitPrice,
    variant.price.unitPriceCurrency,
  )
}
